module.exports = __webpack_public_path__ + "img/Ptuapp7.51d09d5b.png";